import { AxiosResponse } from 'axios';

import axios from 'utils/axios';

import { getAccountId } from './auth';

type RelocationPointsResponse = string[];

export const getRelocationPoints = async (): Promise<RelocationPointsResponse> => {
  const response = (await axios.get(
    `/acc/${getAccountId()}/saved_inputs/relocation_points`,
  )) as AxiosResponse<RelocationPointsResponse>;

  return response.data;
};

export const postRelocationPoint = async (value: string): Promise<RelocationPointsResponse> => {
  const response = (await axios.post(`/acc/${getAccountId()}/saved_inputs/relocation_points`, {
    value,
  })) as AxiosResponse<RelocationPointsResponse>;

  return response.data;
};

export const deleteRelocationPoint = async (value: string): Promise<RelocationPointsResponse> => {
  const response = (await axios.delete(`/acc/${getAccountId()}/saved_inputs/relocation_points`, {
    data: { value },
  })) as AxiosResponse<RelocationPointsResponse>;

  return response.data;
};
